import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Image from "next/image";
export var ImageWithFocalPoint = function(param) {
    var className = param.className, src = param.src, alt = param.alt, width = param.width, height = param.height, focalPoint = param.focalPoint;
    var xPercentage = focalPoint && width ? focalPoint.x * 100 / width : undefined;
    var yPercentage = focalPoint && height ? focalPoint.y * 100 / height : undefined;
    return /*#__PURE__*/ _jsx(Image, {
        className: className,
        src: src,
        alt: alt,
        height: height,
        width: width,
        layout: "fill",
        objectFit: "cover",
        objectPosition: xPercentage && yPercentage ? "".concat(xPercentage, "% ").concat(yPercentage, "%") : ""
    });
};
